import {
  Button,
  Card,
  Menu,
  MenuHandler,
  MenuItem,
  MenuList,
  Typography,
} from "@material-tailwind/react";
import React, { useEffect, useState } from "react";
import { LuPencil, LuPlusCircle } from "react-icons/lu";
import {
  LIST_SUB_BRANCH_TABLE_HEAD,
  mailPattern,
  phoneNumber,
  strongPwd,
} from "../../variables/constants";
import { MdOutlineMoreHoriz, MdPassword } from "react-icons/md";
import { FaRegSquareCheck } from "react-icons/fa6";
import DeleteIcon from "../../assets/CloseOrDelete.svg";
import AddBranch from "../../modal/admin/AddBranch";
import toast from "react-hot-toast";
import {
  deleteServices,
  getServices,
  postServices,
  putServices,
} from "../../apiServices/apiServices";
import NoDataFound from "../../components/NoDataFound";
import LoadingGif from "../../assets/loading_anim.gif";
import { FiEye, FiEyeOff, FiSearch } from "react-icons/fi";
import ChangePasswordModal from "../../modal/ChangePasswordModal";

function ManageBranch() {
  const [headOfficeList, setHeadOfficeList] = useState([]);
  const [branchList, setBrnachList] = useState([]);
  const [modal, setModal] = useState({
    add: false,
    update: false,
    change_password: false,
  });
  const [loading, setLoading] = useState({ screen: false, btn: false });
  const [fieldData, setFieldData] = useState({
    name: "",
    email: "",
    phone: "",
    open: "",
    close: "",
    password: "",
    headbranch: null,
  });
  const [changeFieldData, setChangeFieldData] = useState({
    role: "",
    branch_id: "",
    new_password: "",
    confirm_password: "",
  });
  const [isValid, setIsValid] = useState({
    email: true,
    phone: true,
    password: true,
  });
  const [showPassword, setShowPassword] = useState({});
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const [isConfirmPasswordVisible, setIsConfirmPasswordVisible] =
    useState(false);
  const access_token = localStorage.getItem("gassol-admin-token");

  useEffect(() => {
    fetchHeadOfficeList();
    fetchBranchList(true);
  }, []);

  const fetchHeadOfficeList = async () => {
    try {
      const res = await getServices(`/api/list/my/headbranch`, access_token);
      if (res.responseCode === 200) {
        setHeadOfficeList(res.responseData);
      } else {
        setHeadOfficeList([]);
      }
    } catch (error) {
      toast.error(error);
    }
  };
  const fetchBranchList = async (load_bool) => {
    setLoading({ ...loading, screen: load_bool });

    try {
      const res = await getServices(`/api/list/my/subbranch`, access_token);
      setLoading({ ...loading, screen: false });

      if (res.responseCode === 200) {
        setBrnachList(res.responseData);
      } else {
        setBrnachList([]);
      }
    } catch (error) {
      setLoading({ ...loading, screen: false });
      toast.error(error);
    }
  };

  const handleopenAddModal = () => {
    setLoading({ ...loading, btn: false });
    setModal({ ...modal, add: true });
    setIsPasswordVisible(false);
    setFieldData({
      ...fieldData,
      name: "",
      phone: "",
      email: "",
      password: "",
      close: "",
      open: "",
      headbranch: null,
    });
  };

  const handleOpenUpdateModal = (branch_data) => {
    setLoading({ ...loading, btn: false });
    setModal({ ...modal, update: true });
    setIsPasswordVisible(false);
    setFieldData({
      ...fieldData,
      name: branch_data.name,
      phone: branch_data.phone?.slice(3),
      email: branch_data.email,
      subbranch_id: branch_data._id,
      open: branch_data?.operating_hours?.open || "",
      close: branch_data?.operating_hours?.close || "",
    });
  };

  const handleOpenChangePasswordModal = (branch_data) => {
    setModal({ ...modal, change_password: true });
    setIsPasswordVisible(false);
    setChangeFieldData({
      ...changeFieldData,
      branch_id: branch_data._id,
      role: branch_data.role,
      new_password: "",
      confirm_password: "",
    });
  };

  const handleChangePasswordChange = (e) => {
    if (e.target.name === "new_password") {
      if (strongPwd.test(e.target.value)) {
        setIsValid({ ...isValid, password: true });
      } else {
        setIsValid({ ...isValid, password: false });
      }
    }
    setChangeFieldData({ ...changeFieldData, [e.target.name]: e.target.value });
  };

  const handleChangePasswordSubmit = async (e) => {
    e.preventDefault();
    setLoading({ ...loading, btn: true });

    if (!isValid.password) {
      toast.error(
        "Password must have atleast 1 lowercase, number, special characters and minimum 8 characters."
      );
      setLoading({ ...loading, btn: false });
    } else if (
      changeFieldData.confirm_password !== changeFieldData.new_password
    ) {
      toast.error("New password and confirm password should match.");
    } else {
      try {
        const res = await postServices(
          `/api/change/password`,
          {
            new_pass: changeFieldData.new_password,
            cnfm_pass: changeFieldData.confirm_password,
            id: changeFieldData.branch_id,
            role: changeFieldData.role,
          },
          access_token
        );
        if (res.responseCode === 200) {
          setModal({ ...modal, change_password: false });
          toast.success("Password changed.");
          fetchBranchList(false);
        } else {
          toast.error(res.responseMessage);
        }
      } catch (error) {
        toast.error(error);
      }
    }
  };

  const handleChange = (e) => {
    if (e.target.name === "email") {
      if (mailPattern.test(e.target.value)) {
        setIsValid({ ...isValid, email: true });
      } else {
        setIsValid({ ...isValid, email: false });
      }
    } else if (e.target.name === "phone") {
      if (phoneNumber.test(e.target.value)) {
        setIsValid({ ...isValid, phone: true });
      } else {
        setIsValid({ ...isValid, phone: false });
      }
    } else if (e.target.name === "password") {
      if (strongPwd.test(e.target.value)) {
        setIsValid({ ...isValid, password: true });
      } else {
        setIsValid({ ...isValid, password: false });
      }
    }
    setFieldData({ ...fieldData, [e.target.name]: e.target.value });
  };

  const handleAddSubmit = async (e) => {
    e.preventDefault();
    setLoading({ ...loading, btn: true });

    if (!isValid.phone) {
      toast.error("Please enter a valid phone number.");
      setLoading({ ...loading, btn: false });
    } else if (!isValid.email) {
      toast.error("Please enter a valid email.");
      setLoading({ ...loading, btn: false });
    } else if (!isValid.password) {
      toast.error(
        "Password must have atleast 1 lowercase, number, special characters and minimum 8 characters."
      );
      setLoading({ ...loading, btn: false });
    } else {
      try {
        const res = await postServices(
          `/api/subbranch/add`,
          {
            name: fieldData.name,
            email: fieldData.email,
            phone: "+91" + fieldData.phone,
            password: fieldData.password,
            headbranch_id: fieldData.headbranch?.value,
            open: fieldData.open,
            close: fieldData.close,
          },
          access_token
        );
        setLoading({ ...loading, btn: false });
        if (res.responseCode === 200) {
          setModal({ ...modal, add: false });
          fetchBranchList(false);
        } else {
          toast.error(res.responseMessage);
        }
      } catch (error) {
        setLoading({ ...loading, btn: false });
        toast.error(error);
      }
    }
  };

  const handleUpdateSubmit = async (e) => {
    e.preventDefault();
    setLoading({ ...loading, btn: true });

    if (!isValid.phone) {
      toast.error("Please enter a valid phone number.");
      setLoading({ ...loading, btn: false });
    } else if (!isValid.email) {
      toast.error("Please enter a valid email.");
      setLoading({ ...loading, btn: false });
    } else if (!isValid.password) {
      toast.error(
        "Password must have atleast 1 lowercase, number, special characters and minimum 8 characters."
      );
      setLoading({ ...loading, btn: false });
    } else {
      try {
        const res = await putServices(
          `/api/subbranch/edit?subbranch_id=${fieldData.subbranch_id}`,
          {
            name: fieldData.name,
            email: fieldData.email,
            phone: "+91" + fieldData.phone,
            open: fieldData.open,
            close: fieldData.close,
          },
          access_token
        );
        setLoading({ ...loading, btn: false });
        if (res.responseCode === 200) {
          setModal({ ...modal, update: false });
          fetchBranchList(false);
        } else {
          toast.error(res.responseMessage);
        }
      } catch (error) {
        setLoading({ ...loading, btn: false });
        toast.error(error);
      }
    }
  };

  const handleDeleteBranch = async (branch_data) => {
    if (window.confirm("Do you want to delete this branch?")) {
      try {
        const res = await deleteServices(
          `/api/subbranch/delete?subbranch_id=${branch_data._id}`,
          access_token
        );
        if (res.responseCode === 200) {
          fetchBranchList(false);
        } else {
          toast.error(res.responseMessage);
        }
      } catch (error) {
        toast.error(error);
      }
    }
  };

  const handleBranchSearchChange = async (e) => {
    if (e.target.value.length > 0) {
      try {
        const res = await getServices(
          `/api/list/my/subbranch?searchkey=${e.target.value}`,
          access_token
        );
        if (res.responseCode === 200) {
          setBrnachList(res.responseData);
        } else {
          setBrnachList([]);
        }
      } catch (error) {
        toast.error(error);
      }
    } else {
      fetchBranchList(false);
    }
  };

  const togglePasswordVisibility = () => {
    setIsPasswordVisible(!isPasswordVisible);
  };
  const toggleConfirmPasswordVisibility = () => {
    setIsConfirmPasswordVisible(!isConfirmPasswordVisible);
  };

  const toggleAdminPasswordVisibility = (item_id) => {
    setShowPassword((prev) => ({
      ...prev,
      [item_id]: !prev[item_id],
    }));
  };

  return (
    <>
      <div className="px-6 pb-5 flex flex-col gap-6 pt-4 lg:pt-0">
        <div className="flex justify-between items-center gap-3">
          <p className="text-xl sm:text-2xl md:text-5xl font-bold">
            Manage Branch
          </p>
        </div>

        <div className="flex flex-col md:flex-row justify-between items-center gap-3 relative">
          <div className="relative w-full md:w-auto">
            <input
              type="text"
              className="py-4 pl-12 pr-4 outline-none rounded-xl w-full md:min-w-[280px] xl:min-w-[350px]"
              placeholder="Search by Name"
              style={{
                boxShadow:
                  "0 4px 8px 0 rgba(0, 0, 0, 0), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
              }}
              onChange={handleBranchSearchChange}
            />
            <FiSearch className="absolute top-1/2 transform -translate-y-1/2 left-4 text-[#BDBDBD]" />
          </div>
          <Button
            onClick={handleopenAddModal}
            className="mt-0 font-poppins bg-[#BD3B24] font-medium text-xs sm:text-sm xl:text-base rounded-xl flex items-center gap-2 px-4 sm:px-6 ml-auto outline-none"
          >
            <LuPlusCircle />
            Add
          </Button>
        </div>

        {!loading.screen ? (
          <>
            {branchList.length > 0 ? (
              <Card
                className="h-full w-full rounded-none overflow-x-scroll"
                style={{
                  boxShadow:
                    "0 4px 8px 0 rgba(0, 0, 0, 0), 0 6px 20px 0 rgba(0, 0, 0, 0.06)",
                }}
              >
                <table className="w-full min-w-max table-auto text-left">
                  <thead>
                    <tr>
                      {LIST_SUB_BRANCH_TABLE_HEAD.map((head) => (
                        <th
                          key={head}
                          className="border-b border-blue-gray-100 bg-[#03438D] p-4"
                        >
                          <Typography
                            variant="small"
                            color="blue-gray"
                            className="font-poppins text-white font-semibold uppercase"
                          >
                            {head}
                          </Typography>
                        </th>
                      ))}
                    </tr>
                  </thead>

                  <tbody>
                    {branchList?.map((branch, index) => {
                      return (
                        <tr key={index}>
                          <td className="p-4">
                            <Typography
                              variant="small"
                              color="blue-gray"
                              className="font-poppins font-semibold flex items-center gap-2"
                            >
                              <FaRegSquareCheck className="text-lg text-[#BD3B24]" />
                              {branch.name ?? "-"}
                            </Typography>
                          </td>
                          <td className="p-4">
                            <Typography
                              variant="small"
                              color="blue-gray"
                              className="font-poppins font-semibold flex items-center gap-2"
                            >
                              {branch.headbranch ?? "-"}
                            </Typography>
                          </td>
                          <td className="p-4">
                            <Typography
                              variant="small"
                              color="blue-gray"
                              className="font-poppins font-semibold"
                            >
                              {branch.phone ?? "-"}
                            </Typography>
                          </td>
                          <td className="p-4">
                            <Typography
                              variant="small"
                              color="blue-gray"
                              className="font-poppins font-semibold"
                            >
                              {branch.email ?? "-"}
                            </Typography>
                          </td>
                          <td className="p-4">
                            <Typography
                              variant="small"
                              color="blue-gray"
                              className="font-poppins font-semibold flex items-center gap-2"
                            >
                              {showPassword[branch._id]
                                ? branch.password
                                : "*".repeat(branch?.password?.length)}
                              {!showPassword[branch._id] ? (
                                <FiEyeOff
                                  onClick={() =>
                                    toggleAdminPasswordVisibility(branch._id)
                                  }
                                  className="cursor-pointer"
                                />
                              ) : (
                                <FiEye
                                  onClick={() =>
                                    toggleAdminPasswordVisibility(branch._id)
                                  }
                                  className="cursor-pointer"
                                />
                              )}
                            </Typography>
                          </td>
                          <td className="p-4">
                            <Typography
                              variant="small"
                              color="blue-gray"
                              className="font-poppins text-xl"
                            >
                              <Menu placement="left">
                                <MenuHandler>
                                  <Button className="rounded-full p-2 bg-transparent shadow-none outline-none">
                                    <MdOutlineMoreHoriz className="text-lg text-black" />
                                  </Button>
                                </MenuHandler>
                                <MenuList className="p-0 w-fit min-w-[unset] border-0 shadow-none flex">
                                  <MenuItem
                                    className="w-fit font-poppins rounded-full py-2"
                                    onClick={() => handleDeleteBranch(branch)}
                                  >
                                    <img src={DeleteIcon} alt="" />
                                  </MenuItem>
                                  <MenuItem
                                    className="w-fit font-poppins rounded-full"
                                    onClick={() =>
                                      handleOpenUpdateModal(branch)
                                    }
                                  >
                                    <LuPencil className="font-bold text-lg text-[#03438D]" />
                                  </MenuItem>
                                  <MenuItem
                                    title="Change Password"
                                    className="w-fit font-poppins rounded-full"
                                    onClick={() =>
                                      handleOpenChangePasswordModal(branch)
                                    }
                                  >
                                    <MdPassword className="font-bold text-lg text-[#03438D]" />
                                  </MenuItem>
                                </MenuList>
                              </Menu>
                            </Typography>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </Card>
            ) : (
              <NoDataFound />
            )}
          </>
        ) : (
          <div className="w-full flex justify-center items-center h-[60vh]">
            <img src={LoadingGif} alt="" />
          </div>
        )}
      </div>

      <AddBranch
        open={modal.add}
        onClose={() => setModal({ ...modal, add: false })}
        setFieldData={setFieldData}
        fieldData={fieldData}
        modal={modal}
        headOfficeList={headOfficeList}
        togglePasswordVisibility={togglePasswordVisibility}
        isPasswordVisible={isPasswordVisible}
        handleChange={handleChange}
        handleAddSubmit={handleAddSubmit}
        loading={loading}
      />

      <AddBranch
        open={modal.update}
        onClose={() => setModal({ ...modal, update: false })}
        modal={modal}
        fieldData={fieldData}
        handleChange={handleChange}
        loading={loading}
        handleUpdateSubmit={handleUpdateSubmit}
      />

      <ChangePasswordModal
        open={modal.change_password}
        onClose={() => setModal({ ...modal, change_password: false })}
        isPasswordVisible={isPasswordVisible}
        isConfirmPasswordVisible={isConfirmPasswordVisible}
        togglePasswordVisibility={togglePasswordVisibility}
        toggleConfirmPasswordVisibility={toggleConfirmPasswordVisibility}
        handleChangePasswordChange={handleChangePasswordChange}
        handleChangePasswordSubmit={handleChangePasswordSubmit}
      />
    </>
  );
}

export default ManageBranch;
